import { Clipboard } from '@angular/cdk/clipboard';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EmptyObject } from '../common/utils';
import { inviteLink, TBooking } from '../core/entities';
import { SiteLangMixin } from '../core/lang';
import { SessionService } from '../session.service';
import {
  formatDisplayTime,
  SiteFormatMixin,
} from '../thinkdesks/site.format.mixin';

@Injectable()
export class BookingSharingService extends SiteLangMixin(
  SiteFormatMixin(EmptyObject)
) {
  constructor(
    public override session: SessionService,
    private snackBar: MatSnackBar,
    private clipboard: Clipboard
  ) {
    super();
  }
  async text(object: TBooking) {
    let url = await inviteLink(this.session.lang, object);
    switch (this.session.lang) {
      case 'zh_hk': {
        let s = `
${object.member.name} 邀請你參與活動。
地點: ${this.lang(
          object.space?.location?.name,
          object.space?.location?.name_lang
        )}
Google地圖: ${object.space?.location?.googleMapUrl}
地址: ${this.lang(
          object.space?.location?.address,
          object.space?.location?.address_lang
        )}
房間: ${this.lang(object.space?.name, object.space?.name_lang)}
日期: ${this.formatLongDate(this.session.lang, object.startTime)}
時間: ${formatDisplayTime(this.session, object.startTime)} (${this.formatMins(
          object.durationMins,
          _common
        )})

立即接受邀請，予預約時段即可解鎖/使用房間：${url}
        `;


        // if (object.space.locked) s += `開門密碼: ${object.passcode}`;
        return s;
      }
      case 'zh_cn': {
        let s = `
${object.member.name} 邀请你参与活动。
地点: ${this.lang(
          object.space?.location?.name,
          object.space?.location?.name_lang
        )}
Google地图: ${object.space?.location?.googleMapUrl}
地址: ${this.lang(
          object.space?.location?.address,
          object.space?.location?.address_lang
        )}
房间: ${this.lang(object.space?.name, object.space?.name_lang)}
日期: ${this.formatLongDate(this.session.lang, object.startTime)}
时间: ${formatDisplayTime(
          this.session,
          object.startTime
        )} - ${formatDisplayTime(
          this.session,
          object.endTime
        )} (${this.formatMins(object.durationMins, _common)})

立即接受邀请，予预约时段即可解锁/使用房间：${url}
        `;
        // if (object.space.locked) s += `开门密码: ${object.passcode}`;
        return s;
      }
      case 'en':
      default: {
        let s = `
${object.member.name} is inviting you to join an event.
Location: ${this.lang(
          object.space?.location?.name,
          object.space?.location?.name_lang
        )}
Google Map: ${object.space?.location?.googleMapUrl}
Address: ${this.lang(
          object.space?.location?.address,
          object.space?.location?.address_lang
        )}
Space: ${this.lang(object.space?.name, object.space?.name_lang)}
Date: ${this.formatLongDate(this.session.lang, object.startTime)}
Time: ${formatDisplayTime(
          this.session,
          object.startTime
        )} - ${formatDisplayTime(
          this.session,
          object.endTime
        )} (${this.formatMins(object.durationMins, _common)})

Accept the invitation now and reserve a time slot to unlock/use the room: ${url}
        `;
        // if (object.space.locked) s += `Passcode: ${object.passcode}`;
        return s;
      }
    }
  }

  // async copy(object: TBooking) {
  //   let text = await this.text(object);
  //   this.clipboard.copy(text);
  //   this.snackBar.open(_common.copied);
  // }
  //the above copy function fails on Safari, changed to the following:
  async copy(object: TBooking) {
    const text = await this.text(object);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (!isSafari || (navigator.clipboard && window.isSecureContext)) {
      // Try modern API first (works on desktop Safari 13+, iOS Safari 13.4+ if conditions met)
      try {
        // Request permission if needed (Safari prompts once)
        if (navigator.permissions) {
          const permission = await navigator.permissions.query({ name: 'clipboard-write' as PermissionName });
          if (permission.state === 'denied') {
            throw new Error('Clipboard access denied');
          }
        }
        await navigator.clipboard.writeText(text);
        this.snackBar.open(_common.copied);
        return;
      } catch (err) {
        console.warn('Clipboard API failed, trying fallback...', err);
      }
    }

    // Fallback: Visible textarea for manual copy (iOS-proof)
    this.showCopyModal(text);
  }

  // New helper method: Show a modal/overlay with selectable text
  showCopyModal(text: string) {
    const modal = document.createElement('div');
    modal.style.cssText = `
    position: fixed; top: 0; left: 0; width: 100%; height: 100%; 
    background: rgba(0,0,0,0.5); z-index: 9999; display: flex; align-items: center; justify-content: center;
  `;
    modal.innerHTML = `
    <div style="background: white; padding: 20px; border-radius: 8px; max-width: 100%; width: 300px; text-align: center;">
    <p style="margin-bottom: 10px;">${_common.copy_instruction}</p>
      <textarea readonly style="width: 100%; height: 150px; font-family: monospace; word-break: break-all;" 
                onclick="this.select(); this.setSelectionRange(0, 99999);">${text}</textarea>
      
      <button onclick="this.parentElement.parentElement.remove();" style="margin-top: 20px;" class="text-link link-blue">${_common.close}</button>
    </div>
  `;
    document.body.appendChild(modal);

    // Auto-select on load (iOS will show copy menu on tap anyway)
    setTimeout(() => {
      const textarea = modal.querySelector('textarea') as HTMLTextAreaElement;
      if (textarea) {
        textarea.focus();
        textarea.select();
        textarea.setSelectionRange(0, 99999);
      }
    }, 100);

    // Optional: Auto-close after copy (detect via 'copy' event, but tricky in modal)
    this.snackBar.open(_common.copy_selected, '', { duration: 2000 });
  }


  //WhatsApp Sharing
  ////for Desktop share
  // async share(object: TBooking) {
  //   let text = await this.text(object);
  //   let url = `https://wa.me/?text=${encodeURIComponent(text)}`;
  //   window.open(url);
  // }
  ////for Mobile share
  // async share_toApp(object: TBooking) {
  //   let text = await this.text(object);
  //   let url = `whatsapp://send?text=${encodeURIComponent(text)}`;
  //   window.open(url);
  // }

  //window.open() will be blocked by most modern browsers, changed to the following:
  // Desktop: Open WhatsApp Web (wa.me) in new tab
  async share(object: TBooking) {
    const text = await this.text(object);
    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;

    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener noreferrer'; // Critical for security
    a.style.display = 'none';

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a); // Clean up
  }

  // Mobile: Try to open WhatsApp native app + smart fallback
  share_toApp(object: TBooking) {
    this.text(object).then(text => {
      const encodedText = encodeURIComponent(text);
      const appUrl = `whatsapp://send?text=${encodedText}`;
      const webUrl = `https://wa.me/?text=${encodedText}`;

      // Create hidden link to try opening the app
      const a = document.createElement('a');
      a.href = appUrl;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();

      // Cleanup
      setTimeout(() => {
        document.body.removeChild(a);
      }, 100);

      // Fallback: if WhatsApp app didn't open, redirect to web version
      let fallbackTriggered = false;

      const fallback = () => {
        if (!fallbackTriggered && document.hasFocus()) {
          fallbackTriggered = true;
          window.open(webUrl, '_blank', 'noopener,noreferrer');
        }
      };

      // Try multiple detection methods
      window.addEventListener('blur', () => {
        // If page loses focus → likely app opened
        setTimeout(fallback, 1000);
      });

      // Final safety net
      setTimeout(fallback, 1500);
    });
  }


}
